import React, { useContext, useEffect, useRef, useState } from 'react';
import './ProgressHeader.css';
import {axisMaxLogo} from '../../images/images'
import AudioIcon from '../../images/audioIcon.png'
import leftArrow from '../../images/Back.png'
import { useHistory } from 'react-router-dom'
import { SpeakerContext } from '../../context/SpeakerContext';
import { muteAudio, stopAudio } from '../../utils/handleVoiceAndLang';
import { isNewUI, isPODPosv } from '../../utils/handleProgress';
import lottie from "lottie-web";
import soundIconAnimationJson from '../../images/line-sound-icon-animations.json';
import Header from '../Header/Header';
import LanguageTranslater from '../HOC/LanguageTranslater';
import { soundIcon } from '../../images/btnIcons';

const ProgressHeader = ({ translate }) => {
    const { isVoiceOverDisable, handleVoiceOverState, showbackButton, showAudioIcon, showOldHeader } = useContext(SpeakerContext)
    const soundRef = useRef(null)
    const audEl = useRef(document.querySelector('audio'))
    const router = useHistory()
    const [currentPath, setCurrentPath] = useState('')
    const [showUnmutedIcon, setShowUnmutedIcon] = useState(false)
    const handleSpeakerClick = () => {
        if (!isNewUI()) return
        if (!isVoiceOverDisable) {
            stopVoiceOver(currentPath)
            // console.log("Turn off VO : ", !isVoiceOverDisable, soundRef.current.classList)
            setShowUnmutedIcon(false)
            handleVoiceOverState(true)
        } else {
            setShowUnmutedIcon(true)
            handleVoiceOverState(false)
        }
    }

    const animateIcon = () => {
        const instance = lottie.loadAnimation({
            container: document.querySelector("#sound-animation-icon"),
            animationData: soundIconAnimationJson,
        });

        setTimeout(() => {
            instance.destroy()
            setShowUnmutedIcon(false)
        }, 3000)
    }

    const stopVoiceOver = (currentPathName) => {
        switch (currentPath) {
            case '/vu':
                muteAudio('verify-aud')
                // muteAudio('lang-page-aud')
                return
            case '/customer_feedback':
            case '/video-verification':
                muteAudio('ques-aud')
                return
            case '/selfie':
                muteAudio('selfie-aud')
                return
            case '/video-consent':
                muteAudio('ci-aud')
                return
            default:
                break
        }
    }


    const getCurrentPageAudElId = () => {
        switch (currentPath) {
            case '/vu':
                // stopAudio('verify-aud')
                return 'verify-aud'
                // return 'lang-page-aud'
            case '/customer_feedback':
            case '/video-verification':
                return 'ques-aud'
            case '/selfie':
                return 'selfie-aud'
            case '/video-consent':
                return 'ci-aud'
            default:
                break
        }
    }

    const resumeVoiceOver = () => {
        if (getCurrentPageAudElId()) {
            const audioEl = document.getElementById(getCurrentPageAudElId())
            console.log("Audio Element", audioEl)
            if (audioEl) {
                console.log("Audio Source", audioEl.src)
                // audioEl.play()
                audioEl.muted = false
            }
        }
    }

    useEffect(() => {
        if (showUnmutedIcon) {
            // animateIcon()
            resumeVoiceOver()
        }
    }, [showUnmutedIcon])

    useEffect(() => {
        // animateIcon()
        const pathname = router.location.pathname
        let aud = document.querySelector('audio')
        audEl.current = aud
        setCurrentPath(pathname)
    }, [])

    useEffect(() => {
        const pathname = router.location.pathname
        let aud = document.querySelector('audio')
        audEl.current = aud
        setCurrentPath(pathname)
    }, [router.location.pathname])

    const handleBackButton = () => {
        if (router.location.pathname == '/vu') {
            console.log("YOU Are on Verify Page")
            window.location.reload()
        } else {
            router.goBack()
        }
    }

    const getNewUIStatus = () => {
        if (showOldHeader && !isNewUI() && currentPath !== '/vu') {
            return false
        } else {
            if (!isNewUI() && currentPath !== '/vu') {
                return false
            }
            return true
        }
    }

    return (<>
        {
            getNewUIStatus() ? (
                <>
                    <div className={currentPath === '/vu' ? 'bar-cntnr white-bgrnd' : 'bar-cntnr'}>
                        <div className="statusBar-cstm" id='status-bar' ></div>
                    </div>
                    <div className="header">
                        <div className="left-header">
                            {showbackButton && <div className="left-icon" onClick={handleBackButton} >
                                <img className='back-arrow' src={leftArrow} alt="left icon" />
                            </div>}
                            <img src={axisMaxLogo} alt='axisMaxLogo' />
                            {(currentPath !== '/vu' || (currentPath === '/vu' && showbackButton)) && <div className="proposal-verification">{translate("Proposal Verification")}</div>}
                        </div>
                        {showAudioIcon && !isPODPosv() && <div className={`sound ${isVoiceOverDisable ? 'sound-mute' : null}`} ref={soundRef} onClick={handleSpeakerClick} >
                            {/* <div className="sound--icon fa fa-volume-off"></div> */}
                            <img src={soundIcon} className='sound_icon' alt='sound_icn'/>
                            <div className="sound--wave sound--wave_one"></div>
                            <div className="sound--wave sound--wave_two"></div>
                        </div>}
                        {/* {showUnmutedIcon && <div className='sound-animation-wrapper'>
                <div id='sound-animation-icon'></div>
            </div>} */}
                        {/* <div className="audioIcon">
                <img src={AudioIcon} alt="audio-icon" onClick={handleSpeakerClick} />
                {currentPath == '/vu' && <div className="audioText">An audio guide is available throughout the process, you can adjust the volume accordingly.</div> }
            </div> */}
                    </div>
                </>
            ) : (
                <Header />
            )
        }

    </>

    );
}

export default LanguageTranslater(ProgressHeader);